import Entity from 'utilities/entity';

import Feedback from './feedback';

class Evidence extends Entity {
    feedback() {
        return this.hasMany(Feedback);
    }
}

export default new Evidence();
